import { FC } from 'react';
import { LinearProgress } from '@getgo/chameleon-web-react-wrapper';

import './top-page-loader.css';

const TopPageLoader: FC = (): JSX.Element => {
  return <LinearProgress className="top-page-loader" data-testid="top-page-loader" />;
};

export default TopPageLoader;
